export default [
  {
    path: '/buscaGeral',
    name: 'buscaGeral',
    component: () => import(/* webpackChunkName: "geral" */ './BuscaGeral.vue')
  }
]
